import { getToken } from '@/lib/auth-token';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

export type HttpOptions = RequestInit & NextFetchRequestConfig;

export const api = async <TResponse>(path: string, options?: HttpOptions): Promise<TResponse> => {
  const token = await getToken();

  const requestHeader: HeadersInit = {
    'Content-Type': 'application/json',
  };

  if (token) {
    requestHeader.authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      ...options?.headers,
      ...requestHeader,
    },
  });

  if (response.ok) {
    return response.json();
  }

  const text = await response.text();
  throw new Error(text);
};

function createRequest<TResponse>(
  method: string,
  url: string,
  options?: HttpOptions,
  body?: unknown,
): Promise<TResponse> {
  const opts: HttpOptions = { method, ...options };

  if (body) {
    opts.body = JSON.stringify(body);
  }

  return api<TResponse>(url, opts);
}

export const http = {
  get: <TResponseGet>(url: string, options?: HttpOptions) =>
    createRequest<TResponseGet>('GET', url, options),

  delete: <TResponseGet = void>(url: string, options?: HttpOptions) =>
    createRequest<TResponseGet>('DELETE', url, options),

  post: <TResponse = void>(url: string, body: unknown, options?: HttpOptions) =>
    createRequest<TResponse>('POST', url, options, body),

  patch: <TResponse = void>(url: string, body: unknown, options?: HttpOptions) =>
    createRequest<TResponse>('PATCH', url, options, body),

  put: <TResponse = void>(url: string, body: unknown, options?: HttpOptions) =>
    createRequest<TResponse>('PUT', url, options, body),
};
